import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import moment from 'moment-timezone';
import { CreateBookingService } from '../../create-booking/create-booking.service';
import { CommonService } from '../../../shared/services/common.service';
import { MyBookingsService } from '../../my-bookings/my-bookings.service';
import { mapStyle } from '../../../shared/constants/mapStyle';



@Component({
  selector: 'app-confirm-booking-details',
  templateUrl: './confirm-booking-details.component.html',
  styleUrls: ['./confirm-booking-details.component.scss']
})
export class ConfirmBookingDetailsComponent implements OnInit {
  @Input() booking: any;
  @Input() bookingsList: any;
  @Input() requester: any;
  @Input() miscellConfig: any;
  @Input() configComplete: any;
  @Input()escortConfig: any;
  public config: any[];
  isMultiDayBooking = false;
  passengers: any[] = [];
   uniqueRiders  = {};
   uniqueRiderArray: any;
   stopsDetails: any;
   expandView = true;
   expandRoute = false;
   openRouteMap = false;
   map: any;
   currentLat = 12.8797;
  currentLong = 77.2397;
  coordinates: any = [];
  openInfoWindow: any = null;
  directionsService: google.maps.DirectionsService;
  directionsRenderer: google.maps.DirectionsRenderer;
  multidayTrips: any[] = [];
  estimateData:any={
    "pickUpTime":'',
    "stops":[]
  }
  estimatedResponse:any
  
    constructor(private commonService: CommonService,

              private changeDetectorRef: ChangeDetectorRef, private createBookingService: CreateBookingService, private myBookingService: MyBookingsService) { }

  ngOnInit(): void {
    if (!this.isMultiDayBooking){
      if(this.booking?.stops?.length){
        this.booking.stops.forEach(stop => {
          if(stop.geoCord){
            const [lat, lng] = stop.geoCord?.split(',')?.map(coord => coord ? parseFloat(coord.trim()) : coord);
            if(lat && lng){
              this.coordinates.push({lat, lng, address: stop.address, pointType: stop.pointType });
            }
          }
        });
      }
    this.createBookingService.createStaticUrl(this.coordinates)
    }
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Trip Details Form').elementConfigList;
    });

    this.createBookingService.multiDayBooking.subscribe(res => {
      this.isMultiDayBooking = res;
    });
    if (this.isMultiDayBooking){
      this.coordinates = [];
      this.multidayTrips.push(
        {
          day: 1,
          stops: this.booking.stops.map(item => ({
              address: item.address,
              time: this.getTimein24HourFormat(item.time),
              geoCord: item.geoCord,
              pointType: item.pointType
          }))
        }
      );
      this.booking.multiDays.forEach(day => {
        this.multidayTrips.push({
         day: day.day,
         stops: day.stops.map(item => ({
              address: this.booking.BookingMultiDate ? item.address : item.address.address,
              geoCord: this.booking.BookingMultiDate ? item.geoCord : item.address.geoCord,
              pointType: this.booking.BookingMultiDate ? item.pointType : item.address.pointType
         }))
        });
      });
      this.multidayTrips.forEach(day => {
        day.stops.forEach(stop => {
          if (stop.geoCord) {
            const [lat, lng] = stop.geoCord.split(',').map(coord => parseFloat(coord.trim()));
            this.coordinates.push({ lat, lng, address: stop.address, pointType: stop.pointType });
          }
                 });
      });
    }
    if(this.booking?.stops){
      this.booking.stops.forEach(stop => {
        stop.riders.forEach(rider => {
          if (rider.boardingType == "PickUp") {
            this.passengers.push(rider);
          }
        });
      });
      this.booking.stops.forEach(stop => {
        stop.riders.forEach(rider => {
          if (!this.uniqueRiders[rider.name]) {
            this.uniqueRiders[rider.name] = {
              name: rider.name,
              emplId: rider.emplId,
              email: rider.email,
              mobile: rider.mobile,
              costCenter: rider.costCenter,
              startAddress: null,
              endAddress: null,
              time: this.getTimein24HourFormat(stop.time)
            };
          }

          if (rider.boardingType === 'PickUp') {
            this.uniqueRiders[rider.name].startAddress = stop.address;
          } else if (rider.boardingType === 'Drop') {
            this.uniqueRiders[rider.name].endAddress = stop.address;
          }
        });
      });
    }
    this.uniqueRiderArray = Object.values(this.uniqueRiders);
    this.stopsDetails = this.myBookingService.getStopsCompleteView(this.booking, 'false');

  
    this.estimateData.pickUpTime=this.booking.startTime[0]
    this.booking?.stops.forEach(stop=>{
     this.estimateData.stops.push({
      "stopName":stop.address,
      "geoCord":stop.geoCord
     })
    })

    this.getEstimatedData()
  
  }

  openMap(){
    this.openRouteMap = true;
    this.changeDetectorRef.detectChanges();
    this.map = new google.maps.Map(document.getElementById('map-container'), {
     zoom: 20,
      center: new google.maps.LatLng(this.currentLat, this.currentLong),
      disableDefaultUI: true,
      zoomControl: true,
      styles: mapStyle,
    });

    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.directionsRenderer.setMap(this.map);
        this.plotRouteWithMarkers(this.coordinates);
  }

  getTimein24HourFormat(time) {
    return time ? moment(time, 'DD/MM/YYYY HH/mm/ss').format('HH:mm') : '';
  }
  getAddress(address) {
    return address instanceof Object ? address.address : address;
  }
  toggleBooking()
  {
    this.expandView = !this.expandView;
  }

  plotRouteWithMarkers(coordinates: { lat: number; lng: number ; address: string; pointType: string}[]) {
    const bounds = new google.maps.LatLngBounds();
    const markers: any = [];

    coordinates.forEach(coord => {
      const marker = new google.maps.Marker({
        position: coord,
        map: this.map,
        icon: {
          url: coord.pointType == 'START' ? 'assets/pickup_pin.svg' : coord.pointType == 'END' ? 'assets/drop_pin.svg' : 'assets/stop_pin.svg',
        },
        optimized: true,
        zIndex: 20,
      });

      google.maps.event.addListener(marker, 'click', () => {
        this.openInfoWindowForMarker(marker, coord.address);
      });

      markers.push(marker);
      const markerPosition = marker.getPosition();
      if (markerPosition) {
        bounds.extend(markerPosition);
      }
    });

    this.map.fitBounds(bounds);
    this.getAndDisplayDirections(this.coordinates);
  }

  openInfoWindowForMarker(marker: any, address: string) {
    if (this.openInfoWindow) {
      this.openInfoWindow.close();
    }
    const infoWindow = new google.maps.InfoWindow({
      content: address,
      disableAutoPan: true,
    });

    infoWindow.addListener('domready', () => {
      const infoWindowContent = document.querySelector('.gm-style-iw') as HTMLElement;
      if (infoWindowContent) {
        infoWindowContent.style.padding = '8px';
        infoWindowContent.style.fontSize = '12px';
        infoWindowContent.style.fontWeight = '700';
      }
    });

    infoWindow.open(this.map, marker);
    this.openInfoWindow = infoWindow;
    this.map.panTo(marker.getPosition());
    this.map.setZoom(15);
    this.map.addListener('click', () => infoWindow.close());
  }

  getAndDisplayDirections(waypoints: google.maps.LatLngLiteral[]) {
    const wayPoints: google.maps.DirectionsWaypoint[] = waypoints.map((value) => ({location: new google.maps.LatLng(value)}));
    const request: google.maps.DirectionsRequest = {
      origin: waypoints[0],
      destination: waypoints[waypoints.length - 1],
      waypoints: wayPoints ,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    this.directionsService.route(request, (response: google.maps.DirectionsResult, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        const polylineOptions: google.maps.PolylineOptions = {
          strokeColor: '#6A727D',
          strokeOpacity: 1.0,
          strokeWeight: 3,
        };

        this.directionsRenderer.setOptions({
          polylineOptions,
          suppressMarkers: true
        });
        this.map.setZoom(15);
        this.directionsRenderer.setDirections(response);
      } else {
        console.error('Error fetching directions:', status);
      }
    });
  }

  getEstimatedData(){
    // api

    if( this.miscellConfig?.enablePredictiveStopTime && (this.miscellConfig?.estimateBookingTotalTime || this.miscellConfig?.estimateBookingTotalDistance || this.miscellConfig?.estimateBookingTotalCost)){
      this.createBookingService.fetchEstimateData(this.estimateData,this.booking.vehicleType,this.booking.spotBookingType,this.booking.city).subscribe(res=>{
      this.estimatedResponse=res

      if(this.estimatedResponse)
      this.createBookingService.estimatedData.next(this.estimatedResponse)
    })
    }
  }
}
